export default "__VITE_ASSET__33e076f3__"